import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  login: "/auth/login",
  logout: "/auth/logout",
  token: "/auth/token",
  me: "/users/me",
  users: "/users",
  activateUser: "/users/activate",
  companies: "/organizations",
  projects: "/projects",
  // Лицензии: API v2 (seat-based модель)
  licenses: "/v2/licenses",
  // Выдача/освобождение лицензии конкретному пользователю (клиентские операции v2)
  userLicenses: "/v2/user",
  // Лицензии текущего пользователя: в v2 аналога нет, остаётся v1
  meLicenses: "/users/me/licenses",
  meSessions: "/users/me/sessions",
};

const endpointsSlice = createSlice({
  name: "endpoints",
  initialState,
  reducers: {},
});

export const {} = endpointsSlice.actions;
export default endpointsSlice.reducer;
